/**
 * A random v4 UUID that also works on plain-HTTP origins. Browsers expose crypto.randomUUID() only in secure contexts
 * (HTTPS or localhost), so a LAN address such as http://10.3.2.176:18800 has no randomUUID; getRandomValues() is available
 * everywhere and yields the same identifier. Throws only where no secure random source exists at all.
 */
export function randomUuid(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  if (!c || typeof c.getRandomValues !== "function") throw new Error("This browser cannot create a secure random identifier. Open Celia in a supported browser.");
  const bytes = c.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
